import { type ReactNode, useMemo } from "react";
import { createPortal } from "react-dom";

export const Portal = ({
  children,
  root,
}: {
  children: ReactNode;
  root: HTMLElement | null;
}) => {
  const container = useMemo(() => {
    if (!root) {
      console.warn("Portal root not found, falling back to document.body");
      return document.body;
    }

    return root;
  }, [root]);

  if (!children) {
    return null;
  }

  return createPortal(children, container);
};
